var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReContactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 14.5H12.899C3.099 13.95 1.699 5.65 1.499 3.1C1.449 2.3 2.049 1.55 2.899 1.5H5.649C6.049 1.5 6.449 1.75 6.599 2.15L7.299 4C7.449 4.35 7.349 4.8 7.099 5.1L6.049 6.15C6.399 8.1 7.899 9.6 9.849 9.95L10.949 8.9C11.249 8.6 11.649 8.55 12.049 8.7L13.949 9.45C14.299 9.6 14.549 9.95 14.549 10.4V13C14.499 13.85 13.849 14.5 12.999 14.5ZM2.999 2.5C2.699 2.5 2.499 2.7 2.499 3V3.05C2.749 6 4.199 13 12.949 13.5C13.249 13.5 13.449 13.3 13.499 13.05V10.35L11.599 9.6L10.149 11.05L9.949 11C5.599 10.45 4.999 6.1 4.999 6.05L4.949 5.8L6.349 4.35L5.649 2.5H2.999Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V3H12.3L9 6.3L9.7 7L13 3.7V6H14V2H10Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReContactIcon);
export default __webpack_public_path__ + "static/media/re-contact-icon.362aa3c697d654b5ac71ed6339802302.svg";
export { ForwardRef as ReactComponent };